import { memo, useState } from 'react'

import { emptyFunction } from 'utils'
import { translate } from 'utils/translations'
import { AdvancedTooltip, SpinningLoader, Text } from 'common-components'
import SoundWaveIcon from 'assets/svgr-icons/Soundwave.svg'
import { COLORS } from 'consts/colors'
import { T } from 'consts/translationKeys'
import { AnimatePresence, motion } from 'framer-motion'
import { FRAMER_ANIMATION_PROPS } from '../consts'
import * as Styled from './styled'
import { useSelector } from 'react-redux'
import { ttsSelectors } from 'store/features/tts/selectors'
import { CrownIcon } from 'containers/SubSidebar/styled'

interface IProps {
  onClick: () => void
  isTtsGenerationLoading: boolean
}

const GenerateButton: React.FC<IProps> = (props: IProps) => {
  const { onClick, isTtsGenerationLoading } = props
  const isTtsGenerateActionDisabled = useSelector(
    ttsSelectors.isTtsGenerateActionDisabled
  )

  const isTtsCreditLimitTerminated = useSelector(
    ttsSelectors.isTtsCreditLimitTerminated
  )

  const [buttonWrapperRef, setButtonWrapperRef] =
    useState<HTMLButtonElement | null>(null)

  return (
    <AnimatePresence>
      <motion.div {...FRAMER_ANIMATION_PROPS}>
        <Styled.GenerateButtonContainer
          ref={setButtonWrapperRef}
          onClick={isTtsGenerateActionDisabled ? emptyFunction : onClick}
          $isDisabled={isTtsGenerateActionDisabled}
          $isTtsGenerationLoading={isTtsGenerationLoading}
          $isPremium={isTtsCreditLimitTerminated}
        >
          {isTtsGenerateActionDisabled && (
            <AdvancedTooltip
              btnRef={{ current: buttonWrapperRef }}
              tooltipText={translate(T.INACTIVE_GENERATE_BUTTON_TOOLTIP)}
              tooltipPosition="top"
            />
          )}
          {isTtsGenerationLoading ? (
            <SpinningLoader
              className="loading-spinner"
              size={16}
              loaderColor={COLORS.white}
            />
          ) : isTtsCreditLimitTerminated ? (
            <CrownIcon />
          ) : (
            <SoundWaveIcon />
          )}
          <Text type="h2" color="white" fontWeight="600">
            {translate(T.GENERATE_LABEL)}
          </Text>
        </Styled.GenerateButtonContainer>
      </motion.div>
    </AnimatePresence>
  )
}

export default memo(GenerateButton)
